import Vue from 'vue'
import Vuex from 'vuex'
import Account from './modules/common-apps/account.js'
// import Food from './modules/personal/food.js'
// import Quote from './modules/personal/quote.js'
// // import Ticket from './modules/personal/ticket'
// import Book from './modules/personal/book.js'
// import Emotion from './modules/personal/emotion.js'
// import Contact from './modules/personal/contact.js'
// // import Song from './modules/personal/song'
// import Chat from './modules/personal/chat.js'
// import Article from './modules/common-apps/article.js'
// import DailyAnswers from './modules/personal/daily-answers.js'
// import Financial from './modules/personal/financial.js'  //!!! @TODO use only in personalapp
// import WeekReview from './modules/personal/week-review.js'
// import Tag from './modules/common-apps/tag.js'
// // import Movie from './modules/personal/movie'
// import Link from './modules/personal/link.js'
// // import Belief from './modules/personal/belief'
// import LifeStory from './modules/personal/life-story.js'
// import Moment from './modules/personal/moment.js'
// import AfterIDie from './modules/personal/afteridie.js'
// import Method from './modules/personal/method.js'
// import ToDo from './modules/personal/to-do.js'
// import Calendar from './modules/personal/calendar.js'
// import Box from './modules/personal/box.js'
// // import Goal from './modules/personal/goal'
//
// import Exercise from './modules/mental/exercise.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    account: Account,
    // food: Food,
    // quote: Quote,
    // // ticket: Ticket,
    // book: Book,
    // emotion: Emotion,
    // contact: Contact,
    // // song: Song,
    // chat: Chat,
    // article: Article,
    // dailyAnswers: DailyAnswers,
    // financial: Financial,
    // weekReview: WeekReview,
    // tag: Tag,
    // // movie: Movie,
    // link: Link,
    // // belief: Belief,
    // exercise: Exercise,
    // lifeStory: LifeStory,
    // moment: Moment,
    // toDo: ToDo,
    // calendar: Calendar,
    // box: Box,
    // afteridie: AfterIDie,
    // method: Method
    // // goal: Goal
  }
})
